import React from 'react';

const TEMPLATES = [
  { img: 'https://images.unsplash.com/photo-1528164344705-47542687000d?w=600&q=70', title: '👨‍👩‍👧 亲子欢乐游', desc: '寓教于乐的成长之旅', sub: '带娃出行也能轻松惬意，精选亲子友好景点。', days: '3-5天', ppl: '2-4人' },
  { img: 'https://images.unsplash.com/photo-1502784444187-359ac186c5bb?w=600&q=70', title: '💕 情侣蜜月', desc: '让爱在旅途中升温', sub: '浪漫打卡点、私密餐厅、绝美日落。', days: '5-7天', ppl: '2人' },
  { img: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=600&q=70', title: '🏔️ 小众徒步', desc: '用脚步丈量世界', sub: '远离人群，探索鲜为人知的秘境。', days: '2-4天', ppl: '1-3人' },
  { img: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=600&q=70', title: '🍜 美食探店', desc: '舌尖上的旅行', sub: '从米其林到苍蝇馆子，深度挖掘美食。', days: '2-3天', ppl: '1-2人' },
  { img: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&q=70', title: '📸 文艺摄影', desc: '你负责美 我负责找机位', sub: '精选最佳拍摄点与时段，每张都是大片。', days: '3-5天', ppl: '1-2人' },
  { img: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=600&q=70', title: '🎓 毕业旅行', desc: '青春不散场 奔赴山海', sub: '预算友好有趣好玩，留下特别的毕业回忆。', days: '4-7天', ppl: '3-6人' },
];

const TemplatesSection = () => {
  return (
    <section id="tmpl" className="py-24">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-14" style={{ animation: 'rise .75s ease-out both' }}>
          <div className="text-[11px] tracking-[0.25em] mb-4 cm">SCENE TEMPLATES · 场景模板</div>
          <h2 className="text-3xl md:text-4xl font-bold mb-3 cb is">8片海域，8种心动</h2>
          <p className="text-sm cm">选择一片属于你的海域，AI帮你规划一场有温度的旅行</p>
        </div>
        <div className="grid md:grid-cols-3 gap-5">
          {TEMPLATES.map((t, i) => (
            <div key={i} className="frost overflow-hidden cursor-pointer" style={{ animation: `rise .75s ease-out ${i * 0.06}s both` }}>
              <div className="relative aspect-[4/3]" style={{ background: 'linear-gradient(135deg, var(--deep), var(--mid), var(--glow))' }}>
                <img src={t.img} alt={t.title} className="absolute inset-0 w-full h-full object-cover" loading="lazy" style={{ zIndex: 1 }} onError={(e) => e.target.style.display = 'none'} />
                <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, transparent 35%, rgba(22,37,68,0.85))', zIndex: 2 }} />
                <span className="absolute top-4 right-4 ls ls-tl" style={{ zIndex: 3 }}>热门</span>
                <div className="absolute bottom-0 left-0 right-0 p-5" style={{ zIndex: 3 }}>
                  <div className="text-[11px] cm mb-2">{t.days} · {t.ppl}</div>
                  <h3 className="text-lg font-semibold cb">{t.title}</h3>
                  <p className="text-[13px] cd mt-0.5">{t.desc}</p>
                </div>
              </div>
              <div className="p-5">
                <p className="text-[13px] cm mb-3">{t.sub}</p>
                <a href="#" className="text-[13px] cg hover:underline">启程 →</a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TemplatesSection;
